import React from 'react';
import cl from './CheckoutForm.module.css';
import { useState } from 'react';
import { NavLink } from 'react-router-dom';

const CheckoutForm = (props) => {


  return (
    <form className={cl.contacts_form}>
      <label>
        <p className={cl.form_name}>Contact information</p>
        <input 
          className={cl.input_email}
          type="email"
          name="email" 
          placeholder="Email"
        />
      </label>
      <div>
        <input type="checkbox" id="coding" name="interest" value="keep me up to date on news and exclusive offers" />
        <label for="coding">Keep me up to date on news and exclusive offers</label>
      </div>
      <label>
        <p className={cl.form_name}>Shipping address</p>
        <div>
          <input 
            type="text" 
            name="first name" 
            placeholder="First Name"
            // value={props.contactData.initial.firstName || ""} 
            // onChange={handleChange}
          />
          <input 
            type="text" 
            name="last name" 
            placeholder="Last Name"
            // value={props.contactData.initial.lastName || ""} 
            // onChange={handleChange}
          />
        </div>
        <div>
          <input 
            className={cl.input_email} 
            type="text" 
            id="coding" 
            name="address" 
            placeholder="Address" 
            // value={props.contactData.initial.address || ""} 
            // onChange={handleChange}
          />
        </div>
        <div>
          <input 
            className={cl.input_email} 
            type="text" 
            id="coding" 
            name="apartment" 
            placeholder="Apartment, suite, etc. (optional)" 
            // value={props.contactData.initial.apartment || ""} 
            // onChange={handleChange}
          />
        </div>
        <div>
          <input 
            className={cl.input_email} 
            type="text" 
            id="coding" 
            name="city" 
            placeholder="City"
            // value={props.contactData.initial.city || ""} 
            // onChange={handleChange}
          />
        </div>
        <div>
                    <label><p className={cl.form_name}>Country/Region</p></label>
                    <select name="country">
                        
                            <option value="US" data-id="140" data-countries="United States" data-taxno-status="">United States</option>
                        
                            <option value="CA" data-id="99" data-countries="Canada" data-taxno-status="">Canada</option>
                        
                            <option value="AU" data-id="25" data-countries="Australia" data-taxno-status="">Australia</option>
                        
                            <option value="GB" data-id="237" data-countries="United Kingdom" data-taxno-status="">United Kingdom</option>
                        
                        
                            <option disabled="disabled">----------------------------</option>
                        
                        
                            <option value="AX" data-id="27" data-countries="Aland lslands" data-taxno-status="">Aland lslands</option>
                        
                            <option value="AL" data-id="8" data-countries="Albania" data-taxno-status="">Albania</option>
                        
                            <option value="AD" data-id="21" data-countries="Andorra" data-taxno-status="">Andorra</option>
                        
                            <option value="AG" data-id="24" data-countries="Antigua and Barbuda" data-taxno-status="">Antigua and Barbuda</option>
                        
                            <option value="AU" data-id="25" data-countries="Australia" data-taxno-status="">Australia</option>
                        
                            <option value="AT" data-id="26" data-countries="Austria" data-taxno-status="">Austria</option>
                        
                            <option value="BS" data-id="30" data-countries="Bahamas" data-taxno-status="">Bahamas</option>
                        
                            <option value="BY" data-id="37" data-countries="Belarus" data-taxno-status="">Belarus</option>
                        
                            <option value="BE" data-id="42" data-countries="Belgium" data-taxno-status="">Belgium</option>
                        
                            <option value="BZ" data-id="49" data-countries="Belize" data-taxno-status="">Belize</option>
                        
                            <option value="BM" data-id="38" data-countries="Bermuda" data-taxno-status="">Bermuda</option>
                        
                            <option value="BA" data-id="47" data-countries="Bosnia and Herzegovina" data-taxno-status="">Bosnia and Herzegovina</option>
                        
                            <option value="BV" data-id="53" data-countries="Bouvet&nbsp;Island" data-taxno-status="">Bouvet&nbsp;Island</option>
                        
                            <option value="BG" data-id="39" data-countries="Bulgaria" data-taxno-status="">Bulgaria</option>
                        
                            <option value="CA" data-id="99" data-countries="Canada" data-taxno-status="">Canada</option>
                        
                            <option value="KY" data-id="107" data-countries="Cayman Islands" data-taxno-status="">Cayman Islands</option>
                        
                            <option value="CX" data-id="181" data-countries="Christmas Island" data-taxno-status="">Christmas Island</option>
                        
                            <option value="CC" data-id="108" data-countries="Cocos(Keeling)Islands" data-taxno-status="">Cocos(Keeling)Islands</option>
                        
                            <option value="CK" data-id="114" data-countries="Cook Islands" data-taxno-status="">Cook Islands</option>
                        
                            <option value="CR" data-id="79" data-countries="Costa&nbsp;Rica" data-taxno-status="">Costa&nbsp;Rica</option>
                        
                            <option value="HR" data-id="112" data-countries="Croatia" data-taxno-status="">Croatia</option>
                        
                            <option value="CU" data-id="83" data-countries="Cuba" data-taxno-status="">Cuba</option>
                        
                            <option value="CZ" data-id="103" data-countries="Czech Republic" data-taxno-status="">Czech Republic</option>
                        
                            <option value="DK" data-id="55" data-countries="Denmark" data-taxno-status="">Denmark</option>
                        
                            <option value="DO" data-id="60" data-countries="Dominican Republic" data-taxno-status="">Dominican Republic</option>
                        
                            <option value="SV" data-id="173" data-countries="El&nbsp;Salvador" data-taxno-status="">El&nbsp;Salvador</option>
                        
                            <option value="EE" data-id="20" data-countries="Estonia" data-taxno-status="">Estonia</option>
                        
                            <option value="FK" data-id="74" data-countries="Falkland Islands" data-taxno-status="">Falkland Islands</option>
                        
                            <option value="FO" data-id="65" data-countries="Faroe Islands" data-taxno-status="">Faroe Islands</option>
                        
                            <option value="FJ" data-id="71" data-countries="Fiji Islands" data-taxno-status="">Fiji Islands</option>
                        
                            <option value="FI" data-id="72" data-countries="Finland" data-taxno-status="">Finland</option>
                        
                            <option value="FR" data-id="64" data-countries="France" data-taxno-status="">France</option>
                        
                            <option value="PF" data-id="66" data-countries="Frech Polynesia" data-taxno-status="">Frech Polynesia</option>
                        
                            <option value="TF" data-id="68" data-countries="French&nbsp;Southern and Antarctic Lands" data-taxno-status="">French&nbsp;Southern and Antarctic Lands</option>
                        
                            <option value="DE" data-id="56" data-countries="Germany" data-taxno-status="">Germany</option>
                        
                            <option value="GR" data-id="222" data-countries="Greece" data-taxno-status="">Greece</option>
                        
                            <option value="GL" data-id="82" data-countries="Greenland" data-taxno-status="">Greenland</option>
                        
                            <option value="GD" data-id="81" data-countries="Grenada" data-taxno-status="">Grenada</option>
                        
                            <option value="GP" data-id="84" data-countries="Guadeloupe" data-taxno-status="">Guadeloupe</option>
                        
                            <option value="GT" data-id="212" data-countries="Guatemala" data-taxno-status="">Guatemala</option>
                        
                            <option value="GG" data-id="80" data-countries="Guernsey" data-taxno-status="">Guernsey</option>
                        
                            <option value="HT" data-id="88" data-countries="Haiti" data-taxno-status="">Haiti</option>
                        
                            <option value="HM" data-id="92" data-countries="Heard&nbsp;Island and McDonald Islands" data-taxno-status="">Heard&nbsp;Island and McDonald Islands</option>
                        
                            <option value="HN" data-id="93" data-countries="Honduras" data-taxno-status="">Honduras</option>
                        
                            <option value="HU" data-id="226" data-countries="Hungary" data-taxno-status="">Hungary</option>
                        
                            <option value="IS" data-id="43" data-countries="Iceland" data-taxno-status="">Iceland</option>
                        
                            <option value="IE" data-id="19" data-countries="Ireland" data-taxno-status="">Ireland</option>
                        
                            <option value="IM" data-id="137" data-countries="Isle of Man" data-taxno-status="">Isle of Man</option>
                        
                            <option value="IT" data-id="234" data-countries="Italy" data-taxno-status="">Italy</option>
                        
                            <option value="JM" data-id="228" data-countries="Jamaica" data-taxno-status="">Jamaica</option>
                        
                            <option value="JE" data-id="242" data-countries="Jersey" data-taxno-status="">Jersey</option>
                        
                            <option value="KI" data-id="94" data-countries="Kiribati" data-taxno-status="">Kiribati</option>
                        
                            <option value="LV" data-id="115" data-countries="Latvia" data-taxno-status="">Latvia</option>
                        
                            <option value="LI" data-id="122" data-countries="Liechtenstein" data-taxno-status="">Liechtenstein</option>
                        
                            <option value="LT" data-id="121" data-countries="Lithuania" data-taxno-status="">Lithuania</option>
                        
                            <option value="LU" data-id="124" data-countries="Luxembourg" data-taxno-status="">Luxembourg</option>
                        
                            <option value="MK" data-id="133" data-countries="Macedonia,Former Yugoslav Republic of" data-taxno-status="">Macedonia,Former Yugoslav Republic of</option>
                        
                            <option value="MT" data-id="129" data-countries="Malta" data-taxno-status="">Malta</option>
                        
                            <option value="MQ" data-id="135" data-countries="Martinique" data-taxno-status="">Martinique</option>
                        
                            <option value="MX" data-id="153" data-countries="Mexico" data-taxno-status="">Mexico</option>
                        
                            <option value="MD" data-id="149" data-countries="Moldova" data-taxno-status="">Moldova</option>
                        
                            <option value="MC" data-id="151" data-countries="Monaco" data-taxno-status="">Monaco</option>
                        
                            <option value="ME" data-id="15497" data-countries="Montenegro" data-taxno-status="">Montenegro</option>
                        
                            <option value="MS" data-id="144" data-countries="Montserrat" data-taxno-status="">Montserrat</option>
                        
                            <option value="NR" data-id="158" data-countries="Nauru" data-taxno-status="">Nauru</option>
                        
                            <option value="NL" data-id="90" data-countries="Netherlands" data-taxno-status="">Netherlands</option>
                        
                            <option value="NC" data-id="224" data-countries="New Caledonia" data-taxno-status="">New Caledonia</option>
                        
                            <option value="NZ" data-id="225" data-countries="New Zealand" data-taxno-status="">New Zealand</option>
                        
                            <option value="NI" data-id="160" data-countries="Nicaragua" data-taxno-status="">Nicaragua</option>
                        
                            <option value="NU" data-id="163" data-countries="Niue" data-taxno-status="">Niue</option>
                        
                            <option value="NF" data-id="165" data-countries="Norfolk Island" data-taxno-status="">Norfolk Island</option>
                        
                            <option value="NO" data-id="164" data-countries="Norway" data-taxno-status="">Norway</option>
                        
                            <option value="PA" data-id="35" data-countries="Panama" data-taxno-status="">Panama</option>
                        
                            <option value="PG" data-id="29" data-countries="Papua New Guinea" data-taxno-status="">Papua New Guinea</option>
                        
                            <option value="PN" data-id="167" data-countries="Pitcairn Islands" data-taxno-status="">Pitcairn Islands</option>
                        
                            <option value="PL" data-id="45" data-countries="Poland" data-taxno-status="">Poland</option>
                        
                            <option value="PT" data-id="168" data-countries="Portugal" data-taxno-status="">Portugal</option>
                        
                            <option value="PR" data-id="45505" data-countries="Puerto Rico" data-taxno-status="">Puerto Rico</option>
                        
                            <option value="RE" data-id="123" data-countries="Reunion" data-taxno-status="">Reunion</option>
                        
                            <option value="RO" data-id="126" data-countries="Romania" data-taxno-status="">Romania</option>
                        
                            <option value="RU" data-id="61" data-countries="Russia" data-taxno-status="">Russia</option>
                        
                            <option value="WS" data-id="174" data-countries="Samoa" data-taxno-status="">Samoa</option>
                        
                            <option value="SM" data-id="186" data-countries="San&nbsp;Marino" data-taxno-status="">San&nbsp;Marino</option>
                        
                            <option value="RS" data-id="175" data-countries="Serbia" data-taxno-status="">Serbia</option>
                        
                            <option value="SK" data-id="190" data-countries="Slovakia" data-taxno-status="">Slovakia</option>
                        
                            <option value="SI" data-id="191" data-countries="Slovenia" data-taxno-status="">Slovenia</option>
                        
                            <option value="SB" data-id="196" data-countries="Solomon Islands" data-taxno-status="">Solomon Islands</option>
                        
                            <option value="ES" data-id="221" data-countries="Spain" data-taxno-status="">Spain</option>
                        
                            <option value="KN" data-id="184" data-countries="St.Kitts and Nevis" data-taxno-status="">St.Kitts and Nevis</option>
                        
                            <option value="LC" data-id="185" data-countries="St.Lucia" data-taxno-status="">St.Lucia</option>
                        
                            <option value="PM" data-id="187" data-countries="St.Pierre and Miquelon" data-taxno-status="">St.Pierre and Miquelon</option>
                        
                            <option value="VC" data-id="188" data-countries="St.Vincent and the Grenadines" data-taxno-status="">St.Vincent and the Grenadines</option>
                        
                            <option value="SJ" data-id="192" data-countries="Svalbard and Jan Mayen" data-taxno-status="">Svalbard and Jan Mayen</option>
                        
                            <option value="SE" data-id="171" data-countries="Sweden" data-taxno-status="">Sweden</option>
                        
                            <option value="CH" data-id="172" data-countries="Switzerland" data-taxno-status="">Switzerland</option>
                        
                            <option value="TK" data-id="209" data-countries="Tokelau" data-taxno-status="">Tokelau</option>
                        
                            <option value="TO" data-id="201" data-countries="Tonga" data-taxno-status="">Tonga</option>
                        
                            <option value="TT" data-id="204" data-countries="Trinidad and Tobago" data-taxno-status="">Trinidad and Tobago</option>
                        
                            <option value="TC" data-id="202" data-countries="Turks and Caicos Islands" data-taxno-status="">Turks and Caicos Islands</option>
                        
                            <option value="TV" data-id="206" data-countries="Tuvalu" data-taxno-status="">Tuvalu</option>
                        
                            <option value="UA" data-id="218" data-countries="Ukraine" data-taxno-status="">Ukraine</option>
                        
                            <option value="GB" data-id="237" data-countries="United Kingdom" data-taxno-status="">United Kingdom</option>
                        
                            <option value="US" data-id="140" data-countries="United States" data-taxno-status="">United States</option>
                        
                            <option value="UM" data-id="142" data-countries="United&nbsp;States Minor Outlying Islands" data-taxno-status="">United&nbsp;States Minor Outlying Islands</option>
                        
                            <option value="VU" data-id="211" data-countries="Vanuatu" data-taxno-status="">Vanuatu</option>
                        
                            <option value="VA" data-id="69" data-countries="Vatican City" data-taxno-status="">Vatican City</option>
                        
                            <option value="VG" data-id="214" data-countries="Virgin Islands,British" data-taxno-status="">Virgin Islands,British</option>
                        
                            <option value="WF" data-id="210" data-countries="Wallis and Futuna" data-taxno-status="">Wallis and Futuna</option>
                        
                    </select>
                    <span class="iconfont icon-back select-arrow"></span>
                    <div class="np-ui-input-tips"></div>
                    <input 
                      type="number" 
                      name="zip" 
                      placeholder="Zip Code"
                    />
        </div>
        <div>
          <input 
            className={cl.input_email} 
            type="tel"
            id="coding" 
            name="interest" 
            placeholder="Phone"
          />
        </div>
        </label>
        <div className={cl.bottom_buttons}>
              <NavLink className = {cl.bottom_button_navlink} to='/cart'>
                <svg height="14px" viewBox="0 0 32 32" width="32px">
                    <g>
                      <polyline fill="none" points="   649,137.999 675,137.999 675,155.999 661,155.999  " stroke="#FFFFFF" strokeLinecap="round" strokeLinejoin="round" />
                      <polyline fill="none" points="   653,155.999 649,155.999 649,141.999  " stroke="#FFFFFF" strokeLinecap="round" strokeLinejoin="round"/>
                      <polyline fill="none" points="   661,156 653,162 653,156  " stroke="#FFFFFF" strokeLinecap="round" strokeLinejoin="round"/>
                    </g>
                    <g>
                      <g>
                        <path d="M29.018,17H2.982c-0.397,0-0.756-0.244-0.908-0.617c-0.152-0.374-0.068-0.804,0.213-1.09l11.789-12    c0.384-0.391,1.005-0.391,
                        1.389,0s0.384,1.023,0,1.414L5.354,15h23.663C29.561,15,30,15.448,30,16S29.561,17,29.018,17z"/>
                      </g>
                      <g>
                        <path d="M14.772,29c-0.251,0-0.503-0.098-0.695-0.293l-7.86-8c-0.384-0.391-0.384-1.023,0-1.414s1.005-0.391,1.389,0l7.86,8    c0.384,0.
                        391,0.384,1.023,0,1.414C15.275,28.902,15.023,29,14.772,29z"/>
                      </g>
                    </g>
                </svg>
                <p>Return to cart </p>
              </NavLink>
              <button className = {cl.bottom_button_continue} href={"{offer}"} rel="stylesheet">Continue to shipping</button>
            {/* <input className = {cl.bottom_button_continue} type="submit" value="Continue to shipping" /> */}
        </div>
        
    </form>
  )
}

export default CheckoutForm;